
import { Button } from '@/components/ui/button';
import { RefreshCw, Bug } from 'lucide-react';
import { UserSearch } from './UserSearch';
import { AddUserDialog } from './AddUserDialog';

interface HeaderActionsProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  handleRefresh: () => void;
  showDebugInfo: boolean;
  toggleDebugInfo: () => void;
  onUserAdded: () => void;
}

export const HeaderActions = ({ 
  searchQuery, 
  setSearchQuery, 
  handleRefresh, 
  showDebugInfo, 
  toggleDebugInfo,
  onUserAdded
}: HeaderActionsProps) => {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <h1 className="text-3xl font-bold tracking-tight">User Management</h1>
      
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <UserSearch searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        
        <div className="flex gap-2">
          <AddUserDialog onUserAdded={onUserAdded} />
          
          <Button
            variant="outline"
            size="sm"
            onClick={handleRefresh}
            className="flex items-center gap-1"
          >
            <RefreshCw className="h-4 w-4" />
            Refresh
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            onClick={toggleDebugInfo}
            className={`flex items-center gap-1 ${showDebugInfo ? 'bg-muted' : ''}`}
          >
            <Bug className="h-4 w-4" />
            Debug
          </Button>
        </div>
      </div>
    </div>
  );
};
